import React from 'react'
import Html from 'slate-html-serializer'
import { parseHtml } from 'modules/notes/helpers/helper'

const BLOCK_TAGS = {
  blockquote: 'block-quote',
  p: 'paragraph',
  ul: 'bulleted-list',
  ol: 'numbered-list',
  li: 'list-item',
  h1: 'heading-one',
  h2: 'heading-two',
  h3: 'heading-three',
  h4: 'heading-four',
  h5: 'heading-five',
  h6: 'heading-six',
}

// Add a dictionary of mark tags.
const MARK_TAGS = {
  em: 'italic',
  strong: 'bold',
  u: 'underline',
  code: 'code',
}

const rules = [
  {
    deserialize(el, next) {
      const type = BLOCK_TAGS[el.tagName.toLowerCase()]
      if (!type) return undefined
      return {
        object: 'block',
        type,
        nodes: next(el.childNodes),
      }
    },
    serialize(object, children) {
      if (object.object !== 'block') return null
      switch (object.type) {
        case 'paragraph':
          return <p>{children}</p>
        case 'block-quote':
          return <blockquote>{children}</blockquote>
        case 'heading-one':
          return <h1>{children}</h1>
        case 'heading-two':
          return <h2>{children}</h2>
        case 'list-item':
          return <li>{children}</li>
        case 'numbered-list':
          return <ol>{children}</ol>
        case 'bulleted-list':
          return <ul>{children}</ul>
        default:
          return null
      }
    },
  },
  // Add a new rule that handles marks...
  {
    deserialize(el, next) {
      const type = MARK_TAGS[el.tagName.toLowerCase()]
      if (!type) return undefined
      return {
        object: 'mark',
        type,
        nodes: next(el.childNodes),
      }
    },
    serialize(object, children) {
      if (object && object.object !== 'mark') return null
      switch (object.type) {
        case 'bold':
          return <strong>{children}</strong>
        case 'italic':
          return <em>{children}</em>
        case 'underline':
          return <u>{children}</u>
        case 'code':
          return <code>{children}</code>
        default:
          return null
      }
    },
  },
]

export default new Html({ rules, parseHtml })
